export enum SSESource {
  EStream = 'estream',
  UserStream = 'userstream',
}
